
import Container from 'react-bootstrap/Container';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";


import Button from "react-bootstrap/Button";


import Spinner from 'react-bootstrap/Spinner';
import Form from 'react-bootstrap/Form';

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useState, useRef } from 'react';
import { useAuth } from '../lib/StAuthGiver.js';
import { callApi } from '../lib/Common_funcs.js';
import { OverlayTrigger } from 'react-bootstrap';
import { CustomError } from '../lib/Common_funcs.js';

const WhichEnv = (process.env.REACT_APP_TURBO_ENV === undefined?'aws':'staging');
const Tdebug = (WhichEnv != 'aws');


const updateSiteData = (newSiteId, newSiteName) => {
    const curSiteIdx = localStorage.getItem('curSiteIdx');
    let currentSites = JSON.parse(localStorage.getItem("sites"));
    const curSitesLen = currentSites.length;

    Tdebug && console.log(curSiteIdx);
    Tdebug && console.log(currentSites);

    // currentSites is an arrary of JSON {siteId, siteName}
    // The length will be incremented by one. (Note: Its index
    // will remain the length as it starts from 0).
    currentSites.push(
        {
            siteId: newSiteId,
            siteName: newSiteName
        }
    );

    localStorage.setItem('curSiteIdx', curSitesLen);
    localStorage.setItem('sites', JSON.stringify(currentSites));

    // Update the uDet!
    let new_uDet = JSON.parse(localStorage.getItem('uDet'));
    new_uDet.sites = currentSites;

    localStorage.setItem('uDet', JSON.stringify(new_uDet));

}

export const StSiteCreator = () => {

    const [loading, setLoading] = useState(true);
    const {loginAction, logOut} = useAuth();
    const [error, setError] = useState('');

    const [siteInfo, setSiteInfo] = useState({
        siteName: '',
      });


    // To prevent this from loading twice.
    const isMounted = useRef(false);

    const navigate = useNavigate();

    if (process.env.NODE_ENV == 'development') {
        Tdebug &&  console.log("Node environment is development");
    }
    else {
        Tdebug &&  console.log("Node environment is " + process.env.NODE_ENV);
    }

    if (process.env.REACT_APP_TURBO_ENV === undefined) {
        Tdebug &&  console.log("running on aws")
    }
    else {
        Tdebug &&  console.log(process.env.REACT_APP_TURBO_ENV);
    }

    const getApiServer = () => {
        if (WhichEnv === 'aws') {
            return 'https://api-us.turbosteed.com';
        }
        else {
            return 'https://192.168.1.215:5000';
        }   
    }

    const handleChange = (e) => {
        setSiteInfo({ ...siteInfo, [e.target.name]: e.target.value });
      };

    const addNewSite = () => {
        const fetchData = async() => {

            const rcJson = await callApi('/sites', 'PUT', {}, 
                JSON.stringify({
                    siteName: siteInfo.siteName
                }));
            Tdebug && console.log(rcJson);

            if (rcJson.disposition == 'logout') {
                Tdebug && console.log("Now logging out");
                logOut();
            }

            if (rcJson.httpStatus != 200) {

                if (rcJson.disposition == 'retry') {
                    Tdebug && console.log(rcJson.message);
                    setError('Something went wrong, please retry...')
                    // Handle retry.
                }
                else if (rcJson.disposition == 'abort') {
                    // Handle error.
                    Tdebug && console.log(rcJson.message);
                    setError('Something went wrong.')

                }
                else if ((rcJson.disposition == 'change') || (rcJson.disposition == 'resource exists')) {
                    Tdebug && console.log(rcJson.message);
                    setError(rcJson.message);
                }
                else if (rcJson.disposition == 'empty') {
                    Tdebug && console.log(rcJson.message);
                    Tdebug && console.log(rcJson);
                    setError(rcJson.message);
                }

                setLoading(false);

                // If the cookie has changed, update it.
                if (rcJson.respBody.etac) {
                    loginAction(null, rcJson.etac);
                }
                
            }
            else {

                // If the cookie has changed, update it.
                if (rcJson.respBody.etac) {
                    loginAction(null, rcJson.etac);
                }
                
                Tdebug && console.log("Setting values");
                const newSiteId = rcJson.respBody.siteId;
                
                setError('');
                setLoading(false);
                updateSiteData(newSiteId, siteInfo.siteName);

                Tdebug && console.log("Navigating to: /" + newSiteId + "/home");
                navigate('/' + newSiteId + '/home', {replace: true});
                setError('');
            }
                
        }

        setLoading(true);
        fetchData();
    }

    useEffect(() => {
        
        if (isMounted.current == false) {
            isMounted.current = true;
        }
        else {
            return;
        }

        setLoading(false);
            
    }, []);

    Tdebug && console.log(error);
    Tdebug && console.log(setLoading);

    if (loading == true) {

        return (
            <div className='w-100'>
                <span className="page-title">Add Site</span>
                <div className="position-relative w-100 h-100 d-flex flex-column align-items-center bg-white justify-content-center">
                    <Spinner animation="border" variant="primary" />
                    <div className="mt-2 pt-2">Loading...</div>
                </div>

            </div>
        );
    }
    /*
    else if (error.length) {
        return (
            <div>
                <span className="page-title">Add Site</span>

                <Container className="d-flex flex-column mx-2 px-2"> 
                    {error}
                </Container>
            </div>
        );
    }
        */
    else {

        return (
            <div>
                
                <span className="page-title">Add Site</span>

                
                

                <Container className="d-flex flex-column"> 

                    
                    {(error.length) && 
                        <span className="text-danger"> {error} </span>
                    }
                    <Row className="justify-content-md-center" >  
                    
                        <Col md={12} className="">

                            <Form onSubmit={addNewSite}>


                                <Form.Group controlId="siteName" as={Row} className="my-2">
                                    <Form.Label column sm={3}>Site Name</Form.Label> 
                                    <Col sm={6}>
                                        <Form.Control type="text" name="siteName" onChange={handleChange} required />
                                    </Col>
                                    <Col sm={3}>.turbosteed.com</Col>
                                </Form.Group>


                                <hr />

                                <Button variant="primary" type="submit" className="mt-3">
                                    Submit
                                </Button>
                            </Form>
                        </Col>
                    </Row>

                </Container>

            </div>
                            
        );

    } // Loader is false.
}


export default StSiteCreator;